import {
  GlobalConstantsSonstige,
  InputErrorStateMatcher,
  ValueFormat,
} from 'globales-projekt-angular';

import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalConstantsRegex } from 'globales-projekt-angular';
import { TableSelectKge } from 'src/app/data/table/table-select-kge.model';
import { ConstantsTableColsKge } from 'src/app/immutable/cols/constants-table-cols-kge';
import { LocalService } from 'src/app/services/local.service';
import { Ergebnisse } from 'src/app/data/ws/ergebnis/ergebnisse.model';
import { ApiService } from 'src/app/services/api.service';
import { Kge } from 'src/app/data/ws/dbKlassen/kge.model';
import { Preisstand } from 'src/app/data/ws/dbKlassen/preisstand.model';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-einstellungen',
  templateUrl: './einstellungen.component.html',
  styleUrls: ['./einstellungen.component.css']
})
export class EinstellungenComponent implements OnInit {
  position = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  selectKgeListOld!: TableSelectKge[];
  preisstandOld!: Preisstand;
  preisfaktorOld!: number;

  valueFormat: ValueFormat = new ValueFormat();
  ergebnisse!: Ergebnisse;

  dataSourceKge!: MatTableDataSource<TableSelectKge>;
  displayedColsKge!: string[];
  displayedColsHeaderKge!: string[];  
  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();

  preisstandFormControl: FormControl = new FormControl(null, []);
  preisfaktorFormControl: FormControl = new FormControl(null, [
    Validators.pattern(GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2),
  ]);

  formControlNumberFormatWarningGanzZahlLaeng2OderKomma2Text: string = GlobalConstantsRegex.GANZ_ZAHL_LAENG_2_ODER_KOMMA_2_TEXT;

  isAllSelected: boolean = true;
  showAllSelected: boolean = false;
  isDataChanged: boolean = false;

  constructor(public localService: LocalService,
    private apiService: ApiService
  ) { }



  ngOnInit(): void {

    this.localService.einstellungenComponentRef.next(this);
    this.displayedColsKge = ConstantsTableColsKge.getColumns();
    this.displayedColsHeaderKge = ConstantsTableColsKge.getColumnsHeader();

    this.preisfaktorOld = this.localService.preisfaktor.value;
    this.preisfaktorFormControl.setValue(
      this.valueFormat.getStringDecimal(this.localService.preisfaktor.value, 2)
    );

    this.localService.preisstandList.subscribe((preisstaende) => {
      if (preisstaende && preisstaende.length > 0) {
        this.preisstandFormControl.setValue(this.localService.selectedPreisstand.value.preisstand);
        this.preisstandOld = this.localService.selectedPreisstand.value;
      }

      if (this.localService.kgeList.value.length != 0) {

        this.selectKgeListOld = TableSelectKge.copyObjectList(this.localService.selectedKgeList.value)
        this.dataSourceKge = new MatTableDataSource(
          this.localService.selectedKgeList.value);
        this.isAllSelected = this.dataSourceKge.data.every((entry) => entry.isSelected);

        this.showAllSelected = this.localService.kgeList.value.length !== 0;
        return;
      }

      this.localService.mainComponentRef.value!.waitingForDataSpinner(true);
      this.apiService.postKge(this.localService.selectedGebaeudeList.value.map(entry => entry.idGebaeude)).subscribe((response: Kge[]) => {
        this.localService.kgeList.next(response);


        response.forEach(newKge => {

          this.localService.selectedKgeList.value.push({ ...newKge, isSelected: true });

        });

        this.selectKgeListOld = TableSelectKge.copyObjectList(this.localService.selectedKgeList.value)

        this.dataSourceKge = new MatTableDataSource(
          this.localService.selectedKgeList.value);

        this.showAllSelected = this.localService.kgeList.value.length !== 0;

        this.localService.mainComponentRef.value!.waitingForDataSpinner(false);
      });
    });

  }

  onClickRefresh() {
    if (this.preisfaktorFormControl.invalid) {
      alert(ConstantsTexte.EINSTELLUNG_UNGUELTIGE_EINGABE_PREISFAKTOR);
      return;
    }

    const preisstand = this.localService.preisstandList.value.find(entry => entry.preisstand === this.preisstandFormControl.value)
    if (preisstand) {
      this.localService.selectedPreisstand.next(preisstand);
      this.preisstandOld = preisstand;
    }
    let valueFormat: ValueFormat = new ValueFormat();    
    this.localService.preisfaktor.next(valueFormat.parseNumber(this.preisfaktorFormControl.value));
    this.preisfaktorOld = valueFormat.parseNumber(this.preisfaktorFormControl.value);

    this.dataSourceKge.data.forEach(entry => {
      const entry2 = this.localService.selectedKgeList.value.find(entry2 => entry.idKge === entry2.idKge);
      if (entry2) {
        entry2.isSelected = entry.isSelected;
      }
    });


    this.selectKgeListOld = TableSelectKge.copyObjectList(this.localService.selectedKgeList.value);

    this.isDataChanged = false;

    if (this.localService.selectedGebaeudeList.value.length != 0) {

      this.localService.mainComponentRef.value!.selectedTabIndex = 1;

    }
    else
      alert(ConstantsTexte.EINSTELLUNG_ZURUECKGESETZT);
  }

  changeSelectAll(selectAll: boolean) {
    this.isDataChanged = true;

    this.dataSourceKge.data.forEach((entry) => {
      entry.isSelected = selectAll;
    });

    this.isAllSelected = selectAll;
  }

  changeSelectedKge(idKge: number) {
    this.isDataChanged = true;

    const entry = this.dataSourceKge.data.find((e) => e.idKge === idKge);
    if (entry) {
      entry.isSelected = !entry.isSelected;
    }

    this.isAllSelected = this.dataSourceKge.data.every((entry) => entry.isSelected);
  }

  onClickUndo() {
    this.preisfaktorFormControl.setValue(
      this.valueFormat.getStringDecimal(this.preisfaktorOld, 2)
    );
    this.preisstandFormControl.setValue(this.preisstandOld.preisstand);

    this.localService.selectedKgeList.value.forEach((entry) => {
      const oldEntry: TableSelectKge | undefined = this.selectKgeListOld.find(e => e.idKge === entry.idKge);
      if (oldEntry) {
        entry.isSelected = oldEntry.isSelected;
      }
    });

    this.isAllSelected = this.dataSourceKge.data.every((entry) => entry.isSelected);

    this.isDataChanged = false;

    setTimeout(() => { // Benötigt wegen dem UI refresh
      alert(ConstantsTexte.EINSTELLUNG_ZURUECKGESETZT);
    }, 0);
  }

  onValueChange() {
    this.isDataChanged = true;
  }
}
